<script setup lang="ts">
  import FlowHeaderQC from '@/entities/Flow/components/FlowHeaderQC/FlowHeaderQC.vue'
  import FlowNeedHelpWidgetQC from '@/widgets/Flow/FlowNeedHelpWidgetQC/FlowNeedHelpWidgetQC.vue'
  import { BACK_EVENT_NAME } from './FlowWidget.constants'
  import {
    DEFAULT_FLOW_STEPS_COUNT,
    DEFAULT_FLOW_CURRENT_STEP,
    DEFAULT_FLOW_FIRST_STEP,
  } from '@/shared/constants/flow.constants'
  import { computed } from 'vue'
  interface Props {
    href?: string
    withArrowBack?: boolean
    isRtl?: boolean
    stepsCount?: number
    currentStep?: number
    firstStep?: number
    logoAffinity?: string
    withProgressBar?: boolean
  }

  interface Emits {
    (e: typeof BACK_EVENT_NAME): void
  }

  const props = withDefaults(defineProps<Props>(), {
    withArrowBack: true,
    isRtl: false,
    href: undefined,
    stepsCount: DEFAULT_FLOW_STEPS_COUNT,
    currentStep: DEFAULT_FLOW_CURRENT_STEP,
    firstStep: DEFAULT_FLOW_FIRST_STEP,
    withProgressBar: true,
    logoAffinity: undefined,
  })

  defineEmits<Emits>()

  const currentStep = computed<number>({
    get: () => props.currentStep ?? 0,
    set: (value: number) => (currentStep.value = value ?? 0),
  })
</script>

<template>
  <div class="flow-widget">
    <div id="download-banner-container" />
    <div class="flow-widget__content">
      <FlowHeaderQC
        v-model:current-step="currentStep"
        :with-progress-bar="currentStep > 0 && withProgressBar"
        data-test="flow-header-qc"
      />

      <slot />

      <div class="flow-widget__footer">
        <div class="flow-widget__footer-inner">
          <template v-if="logoAffinity">
            <div class="flow-widget__affinity">
              <img :src="`data:image/png;base64,${logoAffinity}`" />
            </div>
          </template>
          <FlowNeedHelpWidgetQC />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './FlowWidget';

  .ds-flow-widget {
    background-color: var(--colorBgSrfSecondary);
  }
</style>
